import { render, staticRenderFns } from "./v-left-card4.vue?vue&type=template&id=4ae74da0&scoped=true"
import script from "./v-left-card4.vue?vue&type=script&lang=js"
export * from "./v-left-card4.vue?vue&type=script&lang=js"
import style0 from "./v-left-card4.vue?vue&type=style&index=0&id=4ae74da0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae74da0",
  null
  
)

export default component.exports